import Vue from "vue";
import App from "./App.vue";
import 'vant/lib/index.css';

new Vue({
    render: h => h(App)
}).$mount("#app");
